import { useEffect, useState } from "react";
import CTA from "../components/public/CTA";
import PageHero from "../components/PageHero";
import ServiceCard from "../components/ServiceCard";
import { getService, services } from "../data/services";
import { apiRequest } from "../lib/api";

export function Services() {
  const [catalog, setCatalog] = useState(services);
  useEffect(() => {
    let active = true;
    apiRequest("/public/services")
      .then(({ data }) => {
        if (!active || !Array.isArray(data) || !data.length) return;
        const merged = data
          .map((remote) => {
            const local = getService(remote.slug);
            return local
              ? {
                  ...local,
                  title: remote.name || local.title,
                  description:
                    remote.summary || remote.description || local.description,
                }
              : null;
          })
          .filter(Boolean);
        if (merged.length) setCatalog(merged);
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);
  return (
    <>
      <PageHero
        eyebrow="Our services"
        title="One platform for the work that keeps life and business moving."
        copy="Start with a service line or describe what you need. The Bridge will help shape the right path."
      />
      <section id="content" className="section-space bg-mist">
        <div className="container grid gap-5 md:grid-cols-2 lg:grid-cols-3">
          {catalog.map((service, index) => (
            <ServiceCard key={service.slug} service={service} index={index} />
          ))}
        </div>
      </section>
      <CTA />
    </>
  );
}
